import { ChangeDetectionStrategy, Component } from '@angular/core';


@Component({
    selector: 'spark-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SparkHeaderComponent {}
